import { uuidv4 } from "../../lib/utils";
function xhrUpload({
  url,
  method,
  payload,
  onProgress
}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.upload.addEventListener('progress', e => {
      if (e.lengthComputable && onProgress) onProgress(e.loaded, e.total);
    }, false);
    xhr.addEventListener('load', () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        try {
          const result = JSON.parse(xhr.responseText);
          resolve(result);
        } catch (err) {
          reject(err);
        }
      }
    }, false);
    xhr.addEventListener('error', reject, false);
    xhr.open(method, url);
    xhr.send(payload);
  });
}
export const defaultUploader = async req => {
  const timestamp = Date.now();
  const fileType = req.file.name.split('.').reverse()[0] || 'bin';
  const magic = uuidv4();
  const filename = `${req.prefix ? `${req.prefix}-` : ''}${magic}${timestamp}.${fileType}`;
  const formData = new FormData();
  formData.append('data', req.file);
  formData.append('bzid', 'vupload');
  formData.append('filename', filename);
  const response = await xhrUpload({
    url: 'http://imongo.webdev.com/raw_upload',
    method: 'POST',
    payload: formData,
    onProgress: req.onProgress
  });
  if (response.status !== 0) throw new Error(`Server response status ${response.status}: ${response.msg}`);
  const url = response.access[0];
  if (!url) throw new Error('Server have not response url');
  return `https://${url}`;
};
//# sourceMappingURL=uploader.js.map
